<div class="container" id="text" >

    <div class="col-md-12 text-center top20 bot20" *ngIf="test">
        <h1 class="hide-gt-sm"><i class="fa fa-check"></i> Your email was successfully confirmed.</h1>
        <h1 class="hide-sm" [ngClass]="{'mobileVersion': 767.98 > innerWidth}"><i class="fa fa-check" ></i> Please click the "teal" login button above to log into your account.</h1>
        <h3 [ngClass]="{'mobileVersion': innerWidth > 767.98}"><i class="fa fa-check" ></i> Please click the three horizontal bars in the top left and then click on the "Login" button to login to you account.</h3>
        <!--<button ng-click="openLoginPopup()" class="btn btn-default top10"><i class="fa fa-sign-in"></i> LOGIN</button>-->
       
    </div>
</div>